import React, { useState } from 'react';
import '../css/GiftcardRenewal.css'; // Import the CSS file

function GiftcardRenewal() {
  const [ticket, setTicket] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setTicket(e.target.value);
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_BASE_URL}/api/stripe/giftcard-renewal`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ticket }),
      });

      const data = await response.json();
      if (data.status === 200) {
        window.location.href = data.url;
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="giftcard-renewal-container">
      <div className="logo-container">
        <img src={`${process.env.REACT_APP_ASSETS_URL}/logo.png`} alt="Logo" className="logo" />
      </div>
      <h2>Rinnovo Gift Card</h2>
      <div className="form-container">
        <p>Puoi rinnovare la tua gift card entro 6 mesi dalla scadenza al costo di 12€.</p>
        <p>Il rinnovo estende la validità di ulteriori 60 giorni.</p>
        <form className="form" onSubmit={(e) => e.preventDefault()}>
          <label className="label" htmlFor="ticket">Codice Biglietto:</label>
          <input className="input" type="text" name="ticket" value={ticket} onChange={handleChange} required />
          {loading ? (
            <div className="spinner-container">
              <div className="spinner"></div>
            </div>
          ) : (
            <button className="button" type="button" onClick={handleSubmit} disabled={loading}>
              Rinnova
            </button>
          )}
        </form>
      </div>
    </div>
  );
}

// Add spinner styles
const spinnerStyles = `
.spinner {
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 2px solid #3498db;
  width: 12px;
  height: 12px;
  animation: spin 1s linear infinite;
}
`;

// Add keyframes for the spinner animation
const spinnerKeyframes = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`;

// Add spinner container styles
const spinnerContainerStyles = `
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px; // Adjust height as needed
}
`;

// Inject spinner styles into the document
const styleSheet = document.styleSheets[0];
styleSheet.insertRule(spinnerStyles, styleSheet.cssRules.length);
styleSheet.insertRule(spinnerKeyframes, styleSheet.cssRules.length);
styleSheet.insertRule(spinnerContainerStyles, styleSheet.cssRules.length);

export default GiftcardRenewal; 